import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable'
import 'rxjs/Rx';

import { API_URL, API_ForgetPassword, API_Password, API_ResetPassword } from './apiconfig';
import { Password } from './index.model';

//import { Http_Header_Request_Options } from '../core/httpheader';
import { HttpHeader } from '../core/httpheader';

@Injectable()
export class PasswordService {

    private apiUrl: string;
    private requestHeader: HttpHeader = new HttpHeader();
    private Http_Header_Request_Options: RequestOptions;

    constructor(private _http: Http) {
        this.apiUrl = API_URL;
    }

    forgetPassword(model: Password): Promise<Password> {

        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();

        if (model.IsAdmin == 1) {
            model.Url = window.location.href.substr(0, window.location.href.indexOf('#') + 2) + 'admin/resetpassword';
        }
        else {
            model.Url = window.location.href.substr(0, window.location.href.indexOf('#') + 2) + 'citizen/resetpassword';
        }
        
        let body = model;

        return this._http
            .post(this.apiUrl + API_Password + "/" + API_ForgetPassword, body, this.Http_Header_Request_Options)
            .toPromise()
            .then((response) => {
                return response.json() as Password;
            })
            .catch(this.handleError);
    }

    resetPassword(model: Password) {

        let body = model;
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();    

        return this._http.put(this.apiUrl + API_Password + "/" + API_ResetPassword, body, this.Http_Header_Request_Options)
            .map((res: Response) => res);
    }

    // Handle Error

    private handleError(error: any): Promise<any> {
        //console.error('An error occurred', error);
        return Promise.reject(error.message || error);
    }

}


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/core/password.service.ts